
<template>
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="48">
          <a-col :md="6" :sm="24">
            <a-form-item label="关键字">
              <a-input v-model="queryParam.keywords" allowClear  placeholder="搜索关键字"/>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="状态">
              <a-select v-model="queryParam.status" placeholder="请选择"
                        allowClear >
                <a-select-option value="1">正常</a-select-option>
                <a-select-option value="2">隐藏</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="!advanced && 6 || 24" :sm="24">
            <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
              <a-button type="primary" @click="onSearch">查询</a-button>
              <a-button style="margin-left: 8px" @click="() => queryParam = {}">重置</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>

    <div class="table-operator" >

      <a-button type="primary" icon="plus" @click="addHandle" >新建</a-button>
    </div>

    <s-table
            ref="table"
            size="default"
            :columns="columns"
            :data="loadData"
            :alert="{ show: true, clear: () => { this.selectedRowKeys = [] } }"
            :rowSelection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
    >

      <span slot="danwei" slot-scope="text,record">
          <div style="margin-left: 10px; float: left">
            {{record.title}}
            <br/><span style="color: #999">{{record.desc}} </span>
            <br/>
            创建时间 {{record.create_time|timeFormat}}
          </div>
      </span>

      <span slot="jindu" slot-scope="text,record">
        <a-tag v-if="record.status==1" color="green">正常</a-tag>
        <a-tag v-else>隐藏</a-tag>
        <br/>
      </span>
      <span slot="action" slot-scope="text,record">
        <template >
          <a @click="handleEdit(record)">编辑</a>
          <a-divider type="vertical" />
          <a @click="handleUserManage(record)">答题记录</a>
          <a-divider type="vertical" />
          <a-popconfirm title="删除后不可恢复,确定删除吗?" @confirm="deleteHandle(record)"  okText="确定" cancelText="取消">
            <a href="javascript:;">删除</a>
          </a-popconfirm>
        </template>
      </span>
    </s-table>


    <a-modal
        :maskClosable="false"
            title="操作"
            :width="1200"
            :bodyStyle="{maxHeight:'500px','overflowY':'scroll'}"
            v-model="visible"
            @ok="handleOk"
    >
      <a-spin :spinning="saveLoading">
        <a-form :form="form" >


          <a-row :gutter="48">

            <a-col :md="12" :sm="24">
              <a-form-item
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
                      label="名称"
                      hasFeedback
              >
                <a-input  v-decorator="[
          'title',
          {rules: [{ required: true, message: '请输入考试名称' }]}
        ]"
                          placeholder="请输入考试名称"/>
              </a-form-item>

              <a-form-item
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
                      label="描述"
                      extra=""
                      hasFeedback
              >
                <a-textarea   v-decorator="[
          'desc',
          {rules: [ ]}
        ]"
                          placeholder="请输入考试描述"/>
              </a-form-item>

              <a-form-item
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
                      label="activity编号"
                      extra="问卷星的试卷编号"
                      hasFeedback
              >
                <a-input type="number"  v-decorator="[
          'activity_id',
          {rules: [{ required: true, message: '请输入问卷星试卷编号' }]}
        ]"
                          placeholder="请输入问卷星试卷编号"/>
              </a-form-item>
              <a-form-item
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
                      label="问卷链接"
                      extra="问卷星企业外发放中的问卷链接"
                      hasFeedback
              >
                <a-input  v-decorator="[
          'url',
          {rules: [{ required: true, message: '请输入问卷星问卷链接' }]}
        ]"
                          placeholder="请输入问卷星问卷链接"/>
              </a-form-item>
              <a-form-item
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
                      label="查询网址"
                      extra="问卷星成绩数据查询入口"
                      hasFeedback
              >
                <a-input  v-decorator="[
          'result_url',
          {rules: [{ required: true, message: '请输入问卷星查询网址' }]}
        ]"
                          placeholder="请输入问卷星查询网址"/>
              </a-form-item>
            </a-col>
          </a-row>

          </a-row>
          </a-row>
          <a-row :gutter="48">
            <a-col :md="48" :sm="24">
              <a-form-item
                      :labelCol="{
          xs: { span: 12 },
          sm: { span: 4 }}"
                      :wrapperCol="{
          xs: { span: 24 },
          sm: { span: 12 }}"
                      label="状态"
                      hasFeedback
              >
                <a-radio-group v-model="formData.status" buttonStyle="solid">
                  <a-radio-button :value="1">显示</a-radio-button>
                  <a-radio-button :value="2">隐藏</a-radio-button>
                </a-radio-group>
              </a-form-item>
            </a-col>
          </a-row>



        </a-form>

      </a-spin>
      <template slot="footer">
        <a-button key="cancel" @click="handleCancel">取消</a-button>
        <a-button key="forward" :loading="saveLoading" type="primary" @click="handleOk">保存</a-button>
      </template>
    </a-modal>



    <a-modal
        :maskClosable="false"
            title="人员名单"
            :width="1000"
            style="top: 20px;"
            :bodyStyle="{maxHeight:'500px','overflowY':'scroll'}"
            v-model="userVisible"
            @ok="userVisible=false"
    >
      <a-spin :spinning="saveLoading">
        <a-form :form="form">
          <a-table :columns="userColumns" :dataSource="exameUserList" :pagination="userPagination"
                   @change="handleUserTableChange"
                   rowKey="id" :scroll="{ y: 300 }" bordered>
            <div slot="filterDropdown" slot-scope="{ setSelectedKeys, selectedKeys, confirm, clearFilters, column }" class='custom-filter-dropdown'>
              <a-input
                      v-model="userQuery.keywords"
                      placeholder="搜索用户名/身份证号"
                      style="width: 188px; margin-bottom: 8px; display: block;"
              />
              <a-button
                      type='primary'
                      @click="userSearch(selectedKeys, confirm)"
                      icon="search"
                      size="small"
                      style="width: 90px; margin-right: 8px"
              >搜索</a-button>
              <a-button
                      @click="userSearchReset(selectedKeys, confirm)"
                      size="small"
                      style="width: 90px"
              >重置</a-button>
            </div>
            <span slot="name" slot-scope="text,record">
              {{record.name}}<br>{{record.num}}
            </span>
            <span slot="score" slot-scope="text,record">
              {{record.totalvalue}}/{{record.fullscore}}
            </span>
          </a-table>
        </a-form>
      </a-spin>
    </a-modal>



  </a-card>
</template>

<script>
  import STable from '@/components/table/'
  import ATextarea from 'ant-design-vue/es/input/TextArea'
  import AInput from 'ant-design-vue/es/input/Input'
  import EditableCell from '@/components/EditableCell/'
  import PicUploader from '@/components/PicUploader/'
  import FileUploader from '@/components/FileUploader/'
  import areaOptions from '@/utils/area'
  import moment from 'moment'
  import 'moment/locale/zh-cn';
  moment.locale('zh-cn');

  import { addExame ,getExameList,getLogList ,getExameDetail,editExame,deleteExame} from '@/api/wexame'
  export default {
    name: 'KaojiApplyList',
    components: {
      AInput,
      ATextarea,
      FileUploader,
      PicUploader,
      STable,
      EditableCell,
    },
    data () {
      return {
        areaOptions,
        kaoguanPickerShow: false,
        jianduPickerShow: false,
        userVisible: false,
        visible: false,
        saveLoading:false,
        formData:{
          id:0,
          status:1,
          title:'',
          activity_id:'',
        },
        time_range_moment:[],
        time_range:[],
        labelCol: {
//          xs: { span: 24 },
//          sm: { span: 5 },
          xs: { span: 24 },
          sm: { span: 8 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 12 },
        },
        form: this.$form.createForm(this),
        mdl: {},

        // 高级搜索 展开/关闭
        advanced: false,
        // 查询参数
        queryParam: {
          keywords:'',
        },
        // 表头
        columns: [
          {
            title: '#',
            dataIndex: 'id',
            width: '50px'
          },
          {
            title: '考试信息',
            dataIndex: 'danwei',
            scopedSlots: { customRender: 'danwei' },
          },
          {
            title: '参加人数',
            dataIndex: 'member_count',
            scopedSlots: { customRender: 'member_count' },
          },
          {
            title: '状态',
            dataIndex: 'jindu',
            scopedSlots: { customRender: 'jindu' },
          },
          {
            title: '操作',
            dataIndex: 'action',
            fixed: 'right',
            width: 200,
            scopedSlots: { customRender: 'action' },
          }
        ],


        //领取人员表头
        userColumns: [
          {
            title: '#',
            dataIndex: 'id',
            width: '100px'
          },
          {
            title: '用户名',
            dataIndex: 'name',
            width:'250px',
            scopedSlots: {
              filterDropdown: 'filterDropdown',
              filterIcon: 'filterIcon',
              customRender: 'name',
            }
          },
          {
            title: '分数/总分',
            width:'150px',
            dataIndex: 'score',
            scopedSlots: {
              customRender: 'score',
            }
          },
          {
            title: '用时',
            width:'150px',
            dataIndex: 'timetaken',
            customRender: (text) =>  {
              if(text<60){
                return text+'秒';
              }else{
                return parseInt(text/60)+'分'+(text%60)+'秒'
              }
            }
          },
          {
            title: '参加时间',
            width:'150px',
            dataIndex: 'create_time',
            customRender: (text) =>  {
            return moment(text*1000).format('YYYY-MM-DD HH:mm:ss');
            }
    },
    ],
      userPagination:{
        pageSize: 30,
        p: 1,
        showTotal: total => {
          return '总计' + total + '条'
        }
      },
      userQuery:{
        exame_id:0,
                status:0,
                page:1,
                keywords:undefined
      },
      exameUserList:[],


              // 加载数据方法 必须为 Promise 对象
              loadData: parameter => {
        console.log('loadData');
        console.log(this.queryParam);
        let that= this;


        this.queryParam = Object.assign(this.queryParam,parameter);
        return getExameList(this.queryParam)
                        .then(res => {
                  console.log('res');
        return res.data
      })
      },

      selectedRowKeys: [],
              selectedRows: [],
              cashFormData:{
        ids:[],
                to_type:'',
                price:0,
                note:'',
                count:0,
      }
    }
    },
    computed:{
    },
    created(){
    },

    mounted(){
      let that = this;
    },
    methods: {
      moment,
      addHandle(){
        this.formData = {
          id:0,
          status:1,
          title:'',
          activity_id:'',
        },
        this.form.resetFields();
        this.visible = true
      },
      handleCancel(){
        this.visible = false
      },
      handleCancel(){
        this.visible = false
      },
      //展开关闭
      toggleAdvanced() {
        this.advanced = !this.advanced
      },
      handleEdit(record){
        let self = this
        this.visible = true
        getExameDetail({ id: record.id }).then(res => {
          setTimeout(() =>{
            self.form.setFieldsValue({ ...res.data })
            self.formData.id = record.id;
            console.log('handleEdit')
            self.formData = { ...res.data };
          },200)
        })
        // console.log(this.mdl)
      },
      // 查
      onSearch() {
        let self = this;
        self.$refs.table.refresh(false)
      },
      deleteHandle(record){
        let self = this
        deleteExame({ id: record.id }).then(res => {
          self.$message.success('删除成功')
          self.$refs.table.refresh(false)
        }).catch(err =>{
          self.$message.error(err.data.msg)
        })
      },

      // 增改 处理
      handleOk(e) {
        let self = this;
        e.preventDefault()
        this.form.validateFields((err, values) => {
          if (!err) {
            console.log('Received values of form: ', values)
            console.log('Received valuess of formData: ', self.formData)
            self.saveLoading = true;
          if(self.formData.id>0){
            editExame({
              id:self.formData.id,
              title:values.title,
              desc:values.desc,
              activity_id:values.activity_id,
              url:values.url,
              result_url:values.result_url,
              status:self.formData.status,
            }).then(res => {
              self.$message.success('修改成功')
            self.$refs.table.refresh(false)
            self.visible = false;
            self.saveLoading = false;
          }).catch(err =>{
              self.$message.error(err.data.msg);
            self.saveLoading = false;
          })
          }else{
            addExame({
              title:values.title,
              desc:values.desc,
              activity_id:values.activity_id,
              url:values.url,
              result_url:values.result_url,
              status:self.formData.status,
            }).then(res => {
              self.$message.success('修改成功')
            self.$refs.table.refresh(false)
            self.visible = false;
            self.saveLoading = false;
          }).catch(err =>{
              self.$message.error(err.data.msg);
            self.saveLoading = false;
          })

          }
          }
        })
      },

      handleUserManage(record) {
        let self = this
        self.userQuery.exame_id = record.id;
        self.userQuery.keywords = undefined;
        self.userQuery.status = undefined;
        self.userPagination.page = 1;
        self.fetchUserList();
        this.userVisible = true
      },


      fetchUserList(){
        let self = this
        getLogList(Object.assign(self.userQuery,self.userPagination)).then(res => {
          self.exameUserList = res.data.list
          const pagination = { ...this.userPagination }
          pagination.total = res.data.total
          self.userPagination = pagination
        })
      },

      userSearch(selectedKeys,confirm){
        let self = this
        confirm();
        self.fetchUserList();
      },
      userSearchReset(selectedKeys,confirm){
        let self = this;
        confirm();
        self.userQuery.keywords = undefined;
        self.fetchUserList();
      },
      handleUserTableChange(pagination, filters, sorter) {
        console.log('filters',filters);
        let that = this;
        if(filters.grade){
          that.userQuery.grade = filters.grade[0];
        }else{
          that.userQuery.grade = '';
        }
        const pager = { ...this.pagination };
        pager.current = pagination.current;
        that.pagination = pager;
        that.userQuery.pageNo = pagination.current;
        pager.p = pagination.current
        that.fetchUserList();
      },


      kaoguanRemove(index){
        console.log('kaoguanRemove',index);
        this.formData.kaoguan.splice(index,1);
        this.kaoguanPickerShow = false;
      },
      onKaoguanAdd(value){
        console.log('onKaoguanAdd',value);
        let exist = this.formData.kaoguan.filter(item =>{
          return item.num == value.num
        });
        if(exist.length >0){
          this.kaoguanPickerShow = false;
          return ;
        }
        this.formData.kaoguan.push(value);
        this.kaoguanPickerShow = false;
      },
      jianduRemove(index){
        console.log('jianduRemove',index);
        this.formData.jiandu.splice(index,1);
        this.jianduPickerShow = false;
      },
      onJianduAdd(value){
        console.log('onJianduAdd',value);
        let exist = this.formData.jiandu.filter(item =>{
          return item.num == value.num
        });
        if(exist.length >0){
          this.jianduPickerShow = false;
          return ;
        }
        this.formData.jiandu.push(value);
        this.jianduPickerShow = false;
      },


      download(){
        getDownloadUrl(this.queryParam).then(res =>{
          console.log(res);
          window.open(res.data);
        })
      },
      onSelectChange (selectedRowKeys, selectedRows) {
        this.selectedRowKeys = selectedRowKeys
        this.selectedRows = selectedRows
      },

    },
    filters:{
    },
    watch: {
    }
  }
</script>


<style scoped>
  .custom-filter-dropdown {
    padding: 8px;
    border-radius: 4px;
    background: #fff;
    box-shadow: 0 2px 8px rgba(0, 0, 0, .15);
  }

  .highlight {
    background-color: rgb(255, 192, 105);
    padding: 0px;
  }
</style>
